// src/components/LogoTransition.js
import React from "react";
import "./LogoTransition.css";
import logoCheckin from "../assets/logoc.png";

export default function LogoTransition() {
  return (
    <div className="checkin-logo-transition">
      <img
        src={logoCheckin}
        alt="ReflectUS logo transition"
        className="checkin-logo-image"
        key={Date.now()} // ⬅️ KLJUČNO: prisili restart animacije
      />
    </div>
  );
} 
